module.exports = __webpack_public_path__ + "img/totalSec.16c3255d.svg";